import React, {Fragment} from 'react';
import {Skeleton, Typography, useTheme} from '@mui/material';

import {InfoContainer} from './styles';
import {HealthInformationSectionProps} from './types';
import {useHealthProviderDetailsQuery} from 'presentation/modules/guide/health/queries/useHealthProviderDetailsQuery';

export function HealthInformationSection({provider}: HealthInformationSectionProps) {
	const {codigo, cdUf, nmCidade, tipo} = provider;

	const {palette} = useTheme();
	const {
		isLoading,
		data: info,
		isError,
	} = useHealthProviderDetailsQuery({
		cdPrestador: String(codigo),
		cdRedeHap: 'LN',
		nmCidade,
		dsTipo: tipo,
		cdUf,
	});

	if (isError || info === null) {
		return null;
	}

	if (isLoading) {
		return <Skeleton width={200} />;
	}

	return (
		<Fragment>
			{info?.informativo ? (
				<InfoContainer>
					<Typography color={palette.secondary.main} variant="subtitle2" fontWeight={600}>
						{info.informativo.titulo}
					</Typography>
					<Typography variant="body2">{info.informativo.descricao}</Typography>
					<Typography textTransform="uppercase" color={palette.primary.main}>
						{info.informativo.prestadoresSubstitutos.map(
							(item: {codigo: number; nome: string}) => item?.nome,
						)}
					</Typography>
				</InfoContainer>
			) : null}
		</Fragment>
	);
}
